import { ErrorHandler, Injectable } from '@angular/core';
import { BowmanLoggerService } from 'bowman-logger';
import { BowmanLogger } from 'bowman-logger';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
   private log: BowmanLogger = new BowmanLogger(this._loggerService, "GlobalErrorHandler");

   constructor(private _loggerService: BowmanLoggerService) {

   }
   handleError(error) {
    this.log.error(error.message,error.stack);
   }
}